








// vendor
import { defineComponent, computed, ref, PropType } from "@vue/composition-api";
import { RawLocation } from "vue-router";

export default defineComponent({
	props:{
		route:{
			type:Object as PropType<RawLocation>,
			required:true,
		}
	},
	setup(){
		return {};
	}
});

